/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Card, Row, Col, Button } from 'reactstrap';
import cx from 'classnames';

import FaFilePdfO from 'react-icons/lib/fa/file-pdf-o';
import FaSpinner from 'react-icons/lib/fa/spinner';

import { actions as designActions } from '../../actions/design';

import { branch } from '../../utils';

import classes from './ExportReportWrapper.scss';

type PropsType = {
  onDownloadPDF: Function,
  reportLoading: boolean,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ExportReportWrapper extends React.Component<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    return (
      <Row>
        <h4 className={cx('col col-sm-12', classes.cardHeader)}>Export Report</h4>
        <Col>
          <Card body>
            <Row style={{ height: '150px' }}>
              <Col sm={12}>
                <p>
                  Your report is ready to be generated.  Click the button below to download the PDF.
                </p>
              </Col>
              <Col>
                <p>
                  <Button
                    size="md"
                    disabled={this.props.reportLoading}
                    onClick={this.props.onDownloadPDF}
                  >
                    { branch(this.props.reportLoading, <FaSpinner />, <FaFilePdfO />) }
                    {' '}
                    { branch(this.props.reportLoading, 'Loading Report Export', 'Generate Report') }
                  </Button>
                </p>
                <p>Note: this may take some time to complete.</p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: AppStateType): {} => {
  const reportLoading = state.global.generatingReport;

  return {
    reportLoading,
  };
};

function mapDispatchToProps(dispatch: AppDispatch): {} {
  return {
    onDownloadPDF: () => dispatch(designActions.downloadPDF()),
  };
}

const enhancer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  pure);

export default enhancer(ExportReportWrapper);



// WEBPACK FOOTER //
// ./src/components/ExportReportWrapper/ExportReportWrapper.js